module.exports = __webpack_public_path__ + "r-v3/img/ico_dots_horiz_white.f06fd1a7.svg";